var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgEditCalendar(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "a",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 20.125 21",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "m2,20c-.55,0-1.021-.196-1.413-.587-.391-.392-.587-.863-.587-1.413V4c0-.55.196-1.021.587-1.412.392-.392.863-.588,1.413-.588h1v-1c0-.283.096-.521.287-.713.192-.191.43-.287.713-.287s.521.096.713.287c.191.192.287.43.287.713v1h8v-1c0-.283.096-.521.288-.713.191-.191.429-.287.712-.287s.521.096.712.287c.192.192.288.43.288.713v1h1c.55,0,1.021.196,1.413.588.391.391.587.862.587,1.412v6h-2v-2H2v10h7v2H2Zm0-14h14v-2H2v2Zm17.125,9l-2.125-2.125.725-.725c.183-.183.417-.275.7-.275s.517.092.7.275l.725.725c.183.183.275.417.275.7s-.092.517-.275.7l-.725.725Zm-8.125,5.5v-1.2c0-.133.025-.262.075-.387.05-.125.125-.238.225-.338l5-5,2.125,2.125-5,5c-.1.1-.212.175-.337.225-.125.05-.255.075-.388.075h-1.2c-.133,0-.25-.05-.35-.15-.1-.1-.15-.217-.15-.35Z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgEditCalendar);
export default __webpack_public_path__ + "static/media/Edit-Calendar.06cefe9588f83cc2aca7446507e671b8.svg";
export { ForwardRef as ReactComponent };